var t = /* @__PURE__ */ ((e) => (e.DateSince = "dateSince", e.DateTill = "dateTill", e))(t || {});
export {
  t as DateModeEnum
};
